import { render, staticRenderFns } from "./purInitialReturnAction.vue?vue&type=template&id=3258e70f&scoped=true"
import script from "./purInitialReturnAction.vue?vue&type=script&lang=js"
export * from "./purInitialReturnAction.vue?vue&type=script&lang=js"
import style0 from "./purInitialReturnAction.vue?vue&type=style&index=0&id=3258e70f&prod&scoped=true&lang=css"
import style1 from "./purInitialReturnAction.vue?vue&type=style&index=1&id=3258e70f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3258e70f",
  null
  
)

export default component.exports